export default `
	interview {
		...on InterviewItem {
			question {
				content
			}
			answer {
				content
			}
			quote
			image {
				id
				width
				height
				url(transform:coverImageXL)
			}
		}
	}
`;
